import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { useCreatePriceLabel } from '@hero/hooks';
import { recognitionServices } from '@hero/services/order-service/recognition';
import { useGetPaymentMethods } from '@hero/services/organization-service/hooks';

export const useCreateRecognition = ({ options = {} } = {}) => {
  const queryClient = useQueryClient();
  const { data: paymentMethodsData } = useGetPaymentMethods();

  const { isCAActMustBeApplied } = useCreatePriceLabel({});

  const paymentMethods = paymentMethodsData?.paymentMethods || [];

  return useMutation(
    body =>
      recognitionServices.create({
        ...body,
        meta: {
          ...body?.meta,
          caActHasBeenApplied: !!isCAActMustBeApplied
        },
        paymentMethod: paymentMethods[paymentMethods.length - 1]
      }),
    {
      ...options,
      onSuccess: data => {
        options?.onSuccess?.(data.code);
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.useGetRecognitionsKey],
          refetchType: 'active'
        });
      }
    }
  );
};
